import {
    GET_PRODUCTSTATUS_ERROR,
    GET_PRODUCTSTATUS_REQUEST,
    GET_PRODUCTSTATUS_SUCCESS,
    ADD_PRODUCTSTATUS_ERROR,
    ADD_PRODUCTSTATUS_REQUEST,
    ADD_PRODUCTSTATUS_SUCCESS,
    DELETE_PRODUCTSTATUS_REQUEST,
    DELETE_PRODUCTSTATUS_SUCCESS,
    DELETE_PRODUCTSTATUS_ERROR,
    UPDATE_PRODUCTSTATUS_ERROR,
    UPDATE_PRODUCTSTATUS_REQUEST,
    UPDATE_PRODUCTSTATUS_SUCCESS,
} from "./types";

import { BASEURL } from "../../constant/config.js";

const axios = require("axios");

export const getProductStatus = (token, menu_id) => (dispatch) => {
    dispatch({ type: GET_PRODUCTSTATUS_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/product_status`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { menu_id: menu_id || null }
    })
        .then((response) => {
            return dispatch({ type: GET_PRODUCTSTATUS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_PRODUCTSTATUS_ERROR,
                payload: error.response,
            });
        });
};

export const addProductStatus = (token, data, menu_id) => (dispatch) => {
    dispatch({ type: ADD_PRODUCTSTATUS_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/product_status`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { product_status_name: data.productStatusName, is_active: data.check, menu_id },
    })
        .then((response) => {
            return dispatch({ type: ADD_PRODUCTSTATUS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_PRODUCTSTATUS_ERROR,
                payload: error.response,
            });
        });
};
export const updateProductStatus = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_PRODUCTSTATUS_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/product_status/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { product_status_name: data.productStatusName, is_active: data.check },
    })
        .then((response) => {
            return dispatch({ type: UPDATE_PRODUCTSTATUS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_PRODUCTSTATUS_ERROR,
                payload: error.response,
            });
        });
};

export const deleteProductStatus = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_PRODUCTSTATUS_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/product_status/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: DELETE_PRODUCTSTATUS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_PRODUCTSTATUS_ERROR,
                payload: error.response,
            });
        });
};
